import { render } from "./NewAboutCompany.vue?vue&type=template&id=798fad26&scoped=true"
import script from "./NewAboutCompany.vue?vue&type=script&lang=js"
export * from "./NewAboutCompany.vue?vue&type=script&lang=js"

import "./NewAboutCompany.vue?vue&type=style&index=0&id=798fad26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-798fad26"]])

export default __exports__